import { Fragment, useCallback, useState } from "react";
import { Modal, Card, Table } from "antd";
import styled from "styled-components";
import { MdToday, MdKeyboardArrowDown, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Flex } from "@chakra-ui/layout";
import moment from "moment";
import useModalSchedule from "../../../../hooks/useModalSchedule";
import { useSheduleDetailList, useSheduleJanelaExecucaoDetalhe } from "../../../../hooks/useSchedule";
import { ContainerStatus, FilterCheckbox, FilterLegend } from "../HeaderStatus/styles";
import getColumns from "./column";
import { Loading } from "../../Loading";

type QueryParams = {
  DataReferencia?: string;
  DataPeriodoInicial?: string;
  DataPeriodoFim?: string;
  UnidadeId?: string;
  SafraId?: string;
  SafraPeriodoIds?: string;
  OperacaoClasseIds?: string[];

  TalhaoId?: string;
  Data?: string;
}

type ScheduleDetailResponse = {
  operacaoClasseId: string;
  operacaoClasse: string;
  operacaoId: string;
  operacao: string;
  talhaoId: string;
  talhao: string;
  areaHa: number;
  ordemServicoSituacao: string;
  statusAtual: string;
  dataProgramada: string;
}
type ScheduleDetailWindowResponse = ScheduleDetailResponse & {
  periodoDataInicio: string;
  periodoDataFim: string;
}

type Props = {
  queryParams: QueryParams,
  periodoProducao: string;
  schedule: string;
};

function ModalDetail({ queryParams, periodoProducao, schedule }: Props) {
  const { isOpen, setIsOpen, data, datas, talhao, setData, setTalhao, setTalhaoCode, talhaoCode } = useModalSchedule();
  const [_, setAllStatus] = useState(true);
  const [statusPlanejado, setStatusPlanejado] = useState(true);
  const [statusExecutadoParcialmente, setStatusExecutadoParcialmente] = useState(true);
  const [statusExecutado, setStatusExecutado] = useState(true);
  const [statusAtrasado, setStatusAtrasado] = useState(true);
  const query = {
    ...queryParams,
    TalhaoId: talhao,
    Data: data
  }

  const queryJanela = {
    ...queryParams,
    TalhaoId: talhao,
  }

  const { data: dataDetailRes, isFetching: isFetchingDetail } = useSheduleDetailList(query, schedule !== "janela-execucao");
  const { data: dataDetailResJanela, isFetching: isFetchingDetailJanela } = useSheduleJanelaExecucaoDetalhe(queryJanela, datas, schedule === "janela-execucao");
  const dataDetail: ScheduleDetailResponse[] = dataDetailRes ?? [];
  const dataDetailJanela: ScheduleDetailWindowResponse[] = dataDetailResJanela ?? [];

  type DetailItem = ScheduleDetailResponse | ScheduleDetailWindowResponse;


  type Grouped = {
    operation: string;
    total: number;
    list: DetailItem[];
  };

  const [expanded, setExpanded] = useState<number>();

  const resData: DetailItem[] =
    schedule === "janela-execucao" ? dataDetailJanela : dataDetail;

  const res = resData.filter((item: any) => {
    if (statusPlanejado && statusExecutadoParcialmente && statusExecutado && statusAtrasado) return true;
    if (statusPlanejado && item.statusAtual === "Planejada") return true;
    if (statusExecutadoParcialmente && item.statusAtual === "ExecutadaParcialmente") return true;
    if (statusExecutado && item.statusAtual === "Executada") return true;
    if (statusAtrasado && item.statusAtual === "Atrasada") return true;
    return false;
  });

  const result = Object.values(
    (res ?? []).reduce<Record<string, Grouped>>((acc, item) => {
      const key = item.operacao;

      if (!acc[key]) {
        acc[key] = {
          operation: key,
          total: 0,
          list: []
        };
      }

      acc[key].total += item.areaHa;
      acc[key].list.push(item);

      return acc;
    }, {})
  );

  function groupByStatus(list: any[]) {
    const result: any[] = [];

    const grouped = list.reduce((acc, item) => {
      const key = item.statusAtual;

      if (!acc[key]) {
        acc[key] = {
          status: key,
          total: 0,
          items: []
        };
      }

      acc[key].total += item.areaHa;
      acc[key].items.push(item);

      return acc;
    }, {});

    Object.values(grouped).forEach((group: any) => {
      result.push(...group.items);

      result.push({
        isSubtotal: true,
        statusAtual: group.status,
        areaHa: group.total
      });
    });

    return result;
  }

  function closedModal() {
    setIsOpen(false);
    setTalhao('');
    setData('');
    setTalhaoCode('');
  }


  function handleExpand(index: number) {
    setExpanded(expanded === index ? undefined : index);
  }

  function handleCheckAll(checked: boolean) {
    setAllStatus(checked);
    setStatusPlanejado(checked);
    setStatusExecutadoParcialmente(checked);
    setStatusExecutado(checked);
    setStatusAtrasado(checked);
  }

  let month = new Date(data).toLocaleString('pt-BR', { month: 'long' });
  month = month.charAt(0).toUpperCase() + month.slice(1);

  const isS = datas.length > 1 ? 's' : '';

  const windowExecutionTitle = `Janelas de Execução — ${datas.length} janela${isS} ativa${isS} neste dia`;

  const formatDate = useCallback((date: string) => {
    return moment(date).format('DD/MM/YY');
  }, []);

  return (
    <CustomModal
      title={
        <Header>
          <MdToday size={20} />
          Detalhamento -{talhao ? `Talhão ${talhaoCode} - ` : ''} {new Date(data).getDate()} de {month}
          {schedule === "janela-execucao" && <p>{windowExecutionTitle}</p>}
        </Header>
      }
      visible={isOpen}
      width={"95%"}
      onCancel={closedModal}
      destroyOnClose
      centered
      maskClosable={false}
      getContainer={document.body}
      className="teste"
      footer={null}
    >
      <ContainerStatus>
        <FilterCheckbox>
          <input type="checkbox" checked={statusPlanejado && statusExecutadoParcialmente && statusExecutado && statusAtrasado} onChange={(e) => handleCheckAll(e.target.checked)} />
          <FilterLegend color="#000">Todos</FilterLegend>
        </FilterCheckbox>
        <FilterCheckbox>
          <input type="checkbox" checked={statusPlanejado} onChange={(e) => setStatusPlanejado(e.target.checked)} />
          <FilterLegend color="#2196f3">Planejado</FilterLegend>
        </FilterCheckbox>
        <FilterCheckbox>
          <input type="checkbox" checked={statusExecutadoParcialmente} onChange={(e) => setStatusExecutadoParcialmente(e.target.checked)} />
          <FilterLegend color="#ff9800">Executado Parcial</FilterLegend>
        </FilterCheckbox>
        <FilterCheckbox>
          <input type="checkbox" checked={statusExecutado} onChange={(e) => setStatusExecutado(e.target.checked)} />
          <FilterLegend color="#4caf50">Executado</FilterLegend>
        </FilterCheckbox>
        <FilterCheckbox>
          <input type="checkbox" checked={statusAtrasado} onChange={(e) => setStatusAtrasado(e.target.checked)} />
          <FilterLegend color="#f44336">Atrasado</FilterLegend>
        </FilterCheckbox>
      </ContainerStatus>
      {isFetchingDetail || isFetchingDetailJanela ? <Loading /> : result?.map((item: any, index: number) => (
        <Fragment key={item.operation}>
          <Card
            onClick={() => handleExpand(index)}
            style={{ marginTop: 8, cursor: "pointer", backgroundColor: "#f5f5f5", borderRadius: 8 }}
          >
            <Flex justifyContent="space-between" alignItems="center">
              <Flex alignItems="center" gridGap={4}>
                {expanded === index ? (
                  <MdKeyboardArrowDown color="#27ae60" size={22} />
                ) : (
                  <MdOutlineKeyboardArrowRight color="#27ae60" size={22} />
                )}
                <Flex alignItems="center" gridGap={2}>
                  <p style={{ fontWeight: "bold" }}>
                    {item.operation} {schedule === "janela-execucao" && ` - ${formatDate(datas[index]?.PeriodoDataInicio)} à ${formatDate(datas[index]?.PeriodoDataFim)}`} - Total: {item.total?.toLocaleString('pt-BR', {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 2
                    })} ha
                  </p>
                </Flex>
              </Flex>
            </Flex>
          </Card>
          {expanded === index && (
            <RoundedTable
              key="planoOperacionalId"
              dataSource={groupByStatus(item.list)}
              pagination={false}
              columns={getColumns(periodoProducao)}
              scroll={{ x: true, y: 320 }}
              style={{ marginTop: 8 }}
            />
          )}

        </Fragment>
      ))}
    </CustomModal>
  );
}

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    max-height: calc(90vh - 108px);
    overflow-y: scroll;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    background-color: #12619c;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .ant-modal-title {
    color: #fff;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;

const RoundedTable = styled(Table)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }
`;

export default ModalDetail;
